import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

import { emptyArray } from 'ui-components/default-props/empty';
import { createCancelablePromise } from '../../services/promises/create-cancelable-promise';
import { PAGE_SIZE_250, FIRST_PAGE } from '../../services/pagination-service';

// need to find out why any of this stuff exists
const arrayCleansingFunctionPossibly = (data, response) => {
  const dataOut = Object.assign({}, response.data);
  dataOut.pageData = data.map((row) => {
    const newRow = Object.keys(row).reduce((newOb, key) => {
      if (Array.isArray(row[key])) {
        return {
          ...newOb,
          [key]: row[key].length > 0 ? row[key][0] : '',
        };
      }
      return {
        ...newOb,
        [key]: row[key],
      };
    }, {});
    return newRow;
  });
  return dataOut;
};

export const getShipmentsSimple = ({ page = FIRST_PAGE, pageSize = PAGE_SIZE_250, filter, orderBy, orderByDirection, searchTerm }) => {
  const pageData = { pageNumber: page, pageSize };
  const getRequest = axios.post('/shippinggrid/simple', {
    page: pageData,
    filter,
    orderBy,
    orderByDirection,
    searchTerm,
  });
  const getAndTransform = getRequest.then((response) => {
    const data = get(response, 'data.pageData', emptyArray);
    return arrayCleansingFunctionPossibly(data, response);
  });
  const shipments$ = from(getAndTransform);
  return shipments$;
};

export const assignBulkFulfillmentPlanToUser = (fulfillmentPlanIds, userId) => {
  const postAddress = axios.post('/fulfillmentplan/assignUserBulk', { fulfillmentPlanIds, userId }).then((response) => response.data);

  const response$ = from(postAddress);
  return response$;
};

export const getEODOpenShipments = (shipDate) => {
  const request = axios.get(`/shipments/eod/openSummary?shipDate=${shipDate}`).then((res) => res.data);
  return request;
};

export const getEODClosedShipments = (query) => {
  const request = axios.get(`/shipments/eod/closedForms?${query}`).then((res) => res.data.forms);
  return request;
};

export const closeEODShipmentsAsync = (payload) => {
  const request = axios.post('/shipments/eod/closeShipmentsAsync', payload).then((res) => res.data);
  return request;
};

export const getUspsPickupData = (warehouseId) => {
  const getData = axios.get(`/shipments/pickupRequest/${warehouseId}`).then((res) => res.data);
  return createCancelablePromise(getData);
};

export const createUspsPickup = (payload) => {
  const postPickup = axios.post('/shipments/pickupRequest', { ...payload }).then((res) => res);
  return from(postPickup);
};

export const cancelUspsPickup = (requestId) => {
  const cancelPickup = axios.delete(`/shipments/pickupRequest/${requestId}`).then((res) => res);
  return from(cancelPickup);
};

export const amazonOrderNotificationUpdate = (amazonOrders) => {
  const getUpdatedOrderStatuses = axios.post('/shipnotify/amazon/query', amazonOrders).then((res) => res.data);
  return getUpdatedOrderStatuses;
};

export const getEODManifestPageSize = (providerId) => {
  return axios.get(`/shipments/eod/eodPageSize?providerId=${providerId}`);
};
